(function(){
    'use strict';

    $('.stat_tbl-line').on('click', function(event) {
        console.log(event);
        if (event.target.tagName == 'A') {

        } else {
           $(this).toggleClass('stat_tbl-line--active'); 
        }
    })

})();